export enum VehicleGroupApiUrls {
    GetvehicleGroup ='/api/VehicleGroup/GetVehicleGroups',
    UpdatevehicleGroup ='/api/VehicleGroup/UpdateVehicleGroup',
    CreateVehicleGroup = '/api/VehicleGroup/CreateVehicleGroup',
    DeleteVehicleGroup = '/api/VehicleGroup/DeleteVehicleGroup',
    GetVehicleTypes = '/api/VehicleGroup/GetVehicleTypes',
  }